import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/** Link direto do WhatsApp: abre o PDF sem passar pela data de nascimento.
 *
 *  Só existe para trocar de endereço. O documento quem entrega é a API, que
 *  confere o token e reconfere o estado do exame -- laudo reaberto para de
 *  abrir na hora, mesmo com o link ainda dentro do prazo.
 *
 *  Por que uma tela e não um link direto para /api na mensagem: o endereço que
 *  vai para o paciente fica curto e com a cara da clínica, e o dia em que a
 *  entrega mudar de rota, as mensagens já enviadas continuam funcionando. */
export function Documento() {
  const { token } = useParams();

  useEffect(() => {
    if (token) window.location.replace(`/api/publico/laudo?t=${encodeURIComponent(token)}`);
  }, [token]);

  return (
    <main className="documento">
      <p className="vazio">Abrindo o seu exame…</p>
      <noscript>
        {/* Sem JavaScript o efeito acima não roda, e a pessoa ficaria olhando
            uma frase para sempre. */}
        <a href={`/api/publico/laudo?t=${encodeURIComponent(token ?? '')}`}>
          Toque aqui para abrir o exame
        </a>
      </noscript>
    </main>
  );
}
